import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip';

import type { ReactElement } from 'react';

/** Composes onto the existing control; links retain link semantics and keyboard access. */
export function Tooltip({
  children,
  label,
  disabled = false,
}: {
  children: ReactElement;
  label: string;
  disabled?: boolean;
}) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger render={children} disabled={disabled} delay={450} />
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Positioner side="right" sideOffset={8} className="z-[80]">
          <TooltipPrimitive.Popup className="bg-fg text-canvas max-w-64 rounded-md px-3 py-2 text-xs shadow-md">
            {label}
          </TooltipPrimitive.Popup>
        </TooltipPrimitive.Positioner>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
